import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { fetchHandshake } from "@/services/handshake";
import {
  getAmastyMostviewedRelatedProductsBySku,
  getProductBySku,
  getProductFaqs,
  getProductsBySkus,
} from "@/services/product";

// import BreadCrumb from "@/components/global/BreadCrumb";
import Album from "@/components/product/Album";
import Details from "@/components/product/Details";
import FreeGifts from "@/components/product/FreeGifts";
import Tabs from "@/components/product/tabs";
import PDPBottom from "@/components/product/PDPBottom";
import ProductsBulk from "@/components/product/ProductsBulk";
import {
  getMultiProductsRating,
  getProductReviews,
} from "@/services/product/reviews";
import useModifyProductReview from "@/hooks/product-reviews/useModifyProductReview";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import Seo from "@/components/seo";
import BuildBundleModal from "@/components/modals/Bundle";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import { getCookies } from "cookies-next";
import { productSkuString, skusArrayHandler } from "@/helpers/product";
import { event_view_item } from "@/utils/gtm";
import useSWR from "swr";
import FlixMedia from "@/components/product/Flixmedia";
import Script from "next/script";
import { retainKeys } from "@/utils/product";
import ProductBreadCrumb from "@/components/product/ProductBreadCrumb";
import { productSchema } from "@/utils/schema";
import AWSPersonalizeCtx from "@/context/aws-personalize/aws-personalize-context";
import useGetAwsPersonalizeProducts from "@/hooks/useGetAwsPersonalizeProducts";
import {
  CUSTOMER_WHO_VIEWED_ALSO_VIEWED,
  FREQUENTLY_BOUGHT_TOGETHER,
} from "@/services/global/aws-personalize";
import { useRouter } from "next/router";

const ProductPage = ({ product: rawProduct }) => {
  const [fetchProductReviews, setFetchProductReviews] = useState(false);
  const [fetchGetAmastySkus, setFetchGetAmastySkus] = useState(false);
  const [fetchRelatedProducts, setFetchRelatedProducts] = useState(false);
  const [fetchUpSellProducts, setFetchUpSellProducts] = useState(false);
  const [parentQty, setParentQty] = useState(1);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [fetchRelatedAndUpSellRatings, setFetchRelatedAndUpSellRatings] =
    useState(false);
  const [fetchProductFaqs, setFetchProductFaqs] = useState(false);
  console.log({ rawProducttttttttttt: rawProduct });
  useEffect(() => {
    if (rawProduct) {
      event_view_item(rawProduct);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const productSku = productSkuString(rawProduct?.sku);

  const { t } = useTranslation("product");

  const { locale } = useRouter();

  const { handshake } = getCookies();

  // integration with aws personalize
  const { isDirectConnectToAWS, sendPersonalizeEvent } =
    useContext(AWSPersonalizeCtx);

  useEffect(() => {
    if (isDirectConnectToAWS && productSku) {
      sendPersonalizeEvent([
        {
          eventType: "View",
          sentAt: Date.now(),
          itemId: productSku,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirectConnectToAWS, productSku]);

  // get Frequently Bought Together Products from aws personalize
  const {
    products: frequentlyBoughtTogetherProducts,
    ratings: frequentlyBoughtTogetherRatings,
  } = useGetAwsPersonalizeProducts(FREQUENTLY_BOUGHT_TOGETHER, {
    itemId: productSku,
  });

  // get Also Viewed Products  from aws personalize
  const { products: alsoViewedProducts, ratings: alsoViewedRatings } =
    useGetAwsPersonalizeProducts(CUSTOMER_WHO_VIEWED_ALSO_VIEWED, {
      itemId: productSku,
    });

  // total product reviews
  const { data: productReviews } = useSWR(
    fetchProductReviews ? `productReviews/${productSku}/${locale}` : null,
    () => getProductReviews(productSku, locale),
    {
      revalidateOnFocus: false,
    }
  );

  // get related and up sell products skus from amasty if no related or up sell products
  const isGetAmastySkus =
    rawProduct?.custom_related_products?.length === 0 ||
    rawProduct?.up_sell_products?.length === 0;

  const { data: productFaqsRes } = useSWR(
    fetchProductFaqs ? `getProductFaqs/${productSku}/${locale}` : null,
    () => getProductFaqs(productSku, handshake),
    {
      revalidateOnFocus: false,
      revalidateOnMount: fetchProductFaqs,
    }
  );

  // console.log('productFaqsRes//////////////////', productFaqsRes?.data?.data)

  const { data: amastyProductsRes } = useSWR(
    fetchGetAmastySkus ? `getAmastySkus/${productSku}/${locale}` : null,
    () => getAmastyMostviewedRelatedProductsBySku(handshake, productSku, 10),
    {
      revalidateOnFocus: false,
      revalidateOnMount: isGetAmastySkus,
    }
  );

  // get related and up sell products data
  const relatedSkus = skusArrayHandler(
    rawProduct?.custom_related_products?.length > 0
      ? rawProduct?.custom_related_products
      : amastyProductsRes?.data?.data?.[0]?.related?.length > 0
      ? amastyProductsRes?.data?.data?.[0]?.related
      : []
  );
  const upSellSkus = skusArrayHandler(
    rawProduct?.up_sell_products?.length > 0
      ? rawProduct?.up_sell_products
      : amastyProductsRes?.data?.data?.[0]?.upsell?.length > 0
      ? amastyProductsRes?.data?.data?.[0]?.upsell
      : []
  );

  const { data: relatedProductsRes } = useSWR(
    fetchRelatedProducts ? `relatedProducts/${relatedSkus}/${locale}` : null,
    () => getProductsBySkus(handshake, relatedSkus, false),
    {
      revalidateOnFocus: false,
      revalidateOnMount: relatedSkus?.length > 0,
    }
  );
  const { data: upSellProductsRes } = useSWR(
    fetchUpSellProducts ? `upSellProducts/${upSellSkus}/${locale}` : null,
    () => getProductsBySkus(handshake, upSellSkus, false),
    {
      revalidateOnFocus: false,
      revalidateOnMount: upSellSkus?.length > 0,
    }
  );

  const relatedProducts = useMemo(
    () => relatedProductsRes?.data?.data?.products?.filter(item => item?.stock?.is_in_stock) || [],
    [relatedProductsRes]
  );
  const upSellProducts = useMemo(
    () => upSellProductsRes?.data?.data?.products?.filter(item => item?.stock?.is_in_stock) || [],
    [upSellProductsRes]
  );

  // get related and up sell products ratings
  const relatedAndUpSellSkus = skusArrayHandler([
    ...relatedSkus,
    ...upSellSkus,
  ]);

  const { data: relatedAndUpSellRatingsRes } = useSWR(
    fetchRelatedAndUpSellRatings
      ? `relatedAndUpSellRatings/${relatedAndUpSellSkus}/${locale}`
      : null,
    () => getMultiProductsRating(relatedAndUpSellSkus, handshake),
    {
      revalidateOnFocus: false,
      revalidateOnMount: relatedAndUpSellSkus?.length > 0,
    }
  );

  const relatedAndUpSellRatingsData = useMemo(
    () => relatedAndUpSellRatingsRes?.data?.data?.at(1) || [],
    [relatedAndUpSellRatingsRes]
  );

  const [product, setProduct] = useState(rawProduct);
  const [open, setOpen] = useState(false);
  const {
    productScore,
    totalReviewsNum,
    // totalScoreForEachRate,
    // totalPercentageForEachRate,
  } = useModifyProductReview(productReviews?.data);
  const ref = useRef();
  useOnClickOutside([ref], () => {
    setOpen(false);
    setSelectedProducts([]);
  });

  useEffect(() => {
    setProduct(rawProduct);
  }, [rawProduct]);

  // const url =
  //   "/" +
  //   product?._category_?.main_category?.name?.replaceAll(" ", "-") +
  //   "-c-" +
  //   product?._category_?.main_category?.category_id;

  // const BreadCrumbItems = [
  //   {
  //     name: product?._category_?.main_category?.name,
  //     url: url?.replaceAll("-&-", "-")?.toLowerCase(),
  //     active: false,
  //     key: "products",
  //   },
  //   {
  //     name: product?.name || "",
  //     url: "",
  //     active: true,
  //     key: "product",
  //   },
  // ]?.filter(({ name }) => name);

  useEffect(() => {
    setTimeout(() => {
      setFetchProductReviews(true);
      setFetchGetAmastySkus(true);
      setFetchRelatedProducts(true);
      setFetchUpSellProducts(true);
      setFetchRelatedAndUpSellRatings(true);
      setFetchProductFaqs(true);
    }, 5000);
  }, []);

  const bundleSKUs = [
    {
      sku: typeof product?.sku == "string" ? product?.sku : product?.sku?.at(0),
      qty: parentQty,
      ...(product?.type_id == "configurable" && {
        product_type: "configurable",
        product_option: {
          extension_attributes: {
            configurable_item_options: Object.values(
              retainKeys(product?.selectedConfigurations, [
                "attribute_id",
                "option_id",
              ])
            ),
          },
        },
      }),
    },
    ...selectedProducts?.map((p) => ({
      sku: typeof p.sku == "string" ? p?.sku : p?.sku?.at(0),
      qty: p?.qty,
    })),
  ];

  const bc_categories = useMemo(() => {
    // Check if product data is available before proceeding
    if (!product || !product.category) {
      return [];
    }
    const getCategory = (level) => product?._category_?.sub_categories.find(c => c.level === level)
    const cats = [getCategory(2), getCategory(3)].filter(Boolean)

    return cats
      .map((cat) => ({
        name: cat?.name,
        url: cat?.url_key
          ? `${cat?.url_key}-c-${cat?.category_id}`
          : `${cat?.name?.replaceAll(" ", "-")?.toLowerCase()}-c-${
              cat?.category_id
            }`,
      }))
      .filter(({ name }) => name);
  }, [product]);
  return (
    <>
      <div className="videoPlayerPDP">
        <Seo
          title={product?.name || ""}
          description={product?.meta_description}
          image={product?._media_?.image?.at(0)?.image}
        >
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(
                productSchema(product, bc_categories, locale),
                null,
                2
              ),
            }}
          />
        </Seo>
        {/* <BreadCrumb items={BreadCrumbItems} /> */}
        <ProductBreadCrumb
          Current={<div className="text-balance">{product?.name}</div>}
          parentCategory={bc_categories}
        />
        <div className="my-4 sm:my-8 sm:*:mb-8">
          <div className="grid w-11/12 grid-cols-12 gap-4 mx-auto">
            <Album product={product} t={t} />
            {/* BUG: Details component is what is causing error "document is not defined" */}
            <Details
              product={product}
              setOpen={setOpen}
              productScore={productScore}
              relatedProducts={relatedProducts}
              totalReviewsNum={totalReviewsNum}
              setProduct={setProduct}
            />
          </div>
          <FreeGifts productFees={product?.product_fees} />
          <section className="w-11/12 mx-auto">
            {relatedProducts?.length ? (
              <ProductsBulk
                title={t("Related Products")}
                products={relatedProducts.map((product) => ({
                  ...product,
                  rating: Object.entries(relatedAndUpSellRatingsData)
                    ?.find((r) => r?.at(0) === product.sku)
                    ?.at(1) || { count: "0", rating: "0.0" },
                }))}
                locale={locale}
              />
            ) : null}
          </section>
          <section className="w-11/12 mx-auto">
            {frequentlyBoughtTogetherProducts?.length > 0 && (
              <ProductsBulk
                title={t("Frequently Bought Together Products")}
                products={frequentlyBoughtTogetherProducts.map((product) => ({
                  ...product,
                  rating: Object.entries(frequentlyBoughtTogetherRatings)
                    ?.find((r) => r?.at(0) === product.sku)
                    ?.at(1) || { count: "0", rating: "0.0" },
                }))}
                locale={locale}
              />
            )}
          </section>
          <section className="w-11/12 mx-auto">
            {alsoViewedProducts?.length > 0 && (
              <ProductsBulk
                title={t("Customer Who Viewed This Product Also Viewed")}
                products={alsoViewedProducts.map((product) => ({
                  ...product,
                  rating: Object.entries(alsoViewedRatings)
                    ?.find((r) => r?.at(0) === product.sku)
                    ?.at(1) || { count: "0", rating: "0.0" },
                }))}
                locale={locale}
              />
            )}
          </section>
          <section className="w-11/12 mx-auto">
            {upSellProducts?.length ? (
              <ProductsBulk
                title={t("Recommended Accessories")}
                products={upSellProducts.map((product) => ({
                  ...product,
                  rating: Object.entries(relatedAndUpSellRatingsData)
                    ?.find((r) => r?.at(0) === product.sku)
                    ?.at(1) || { count: "0", rating: "0.0" },
                }))}
                locale={locale}
              />
            ) : null}
          </section>
          <div id="flix-inpage" />
          <div id="flix-minisites" />

          <FlixMedia product={product} />
          <div className="sm:w-11/12 sm:mx-auto">
            {/* <ReviewSummary
            productScore               = {productScore}
            totalReviewsNum            = {totalReviewsNum}
            totalScoreForEachRate      = {totalScoreForEachRate}
            totalPercentageForEachRate = {totalPercentageForEachRate}
          /> */}
            <Tabs
              {...{
                parentProduct: product || {},
                bundleSKUs: bundleSKUs || [],
                description: product?.description || [],
                specifications: product?.specifications_home_appliances || [],
                product_attributes: product?.product_attributes || [],
                accessories: product?.accessories || [],
                productReviews: productReviews?.data || {},
                bundle_discounts: product?.bundle_discounts || [],
                add_on_savings: product?.add_on_savings || [],
                relatedProducts: relatedProducts || [],
                faqs: productFaqsRes?.data?.data || [],
              }}
            />
          </div>
        </div>
        <PDPBottom />
        {open && (
          <section className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-black bg-opacity-60 z-modal">
            <div
              ref={ref}
              className="w-11/12 p-4 max-h-[90vh] overflow-y-auto mx-auto bg-white rounded-md"
            >
              <BuildBundleModal
                {...{
                  product,
                  setProduct,
                  setOpen,
                  relatedProducts,
                  bundleSKUs,
                  parentQty,
                  setParentQty,
                  selectedProducts,
                  setSelectedProducts,
                  bundles: product?.ulmod_bundles,
                  t,
                }}
              />
            </div>
          </section>
        )}
      </div>
      <Script async id="pdp-script-24-stream" strategy="lazyOnload">
        {`
          (function(w,d,s,o){var f=d.getElementsByTagName(s)[0];var j=d.createElement(s);
            w.TTLStreamReady = new Promise((resolve) => {
            j.async=true;j.src= 'https://content.24ttl.stream/widget.js';f.parentNode.insertBefore(j,f);
            j.onload = function () {
                w.ttlStream = new TTLStream(o); resolve(w.ttlStream);
              };
            });
          })(window,document,'script',{});
        `}
      </Script>
      <Script async id="pdp-script-24-stream-2" strategy="lazyOnload">
        {`
          TTLStreamReady.then(() => {
            ttlStream.findAndInsert({
              "brand": "${rawProduct?.option_text_brand?.[0]}",
              "productId": "${
                Array.isArray(rawProduct?.sku)
                  ? rawProduct?.sku?.[0]
                  : rawProduct?.sku
              }",
              "retailerDomain": "abdulwahed.com",
              "templateType": "master_template",
              "resultType": "html",
              "contentType": "minisite",
              "el": ".exampleWrapperContent",
              "language": "${locale === "en" ? "sa_en" : "sa_ar"}"
            });
          });
        `}
      </Script>
    </>
  );
};

export default ProductPage;

export async function getServerSideProps({
  locale,
  req,
  res,
  params: { rewrite_url },
}) {
  const parsedSku = rewrite_url?.slice(rewrite_url.lastIndexOf("-p-") + 3); // parsed sku from url

  // get handshake from cookies or generate new handshake
  const handshake = await fetchHandshake({ req, res, locale });

  // fetch product data
  const { data: product, error } = await getProductBySku(handshake, parsedSku);
  console.log("product===========================================", product);
  if (
    product?.data === null ||
    error ||
    (Array.isArray(product?.data) && product?.data?.length === 0)
  ) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      product: product?.data?.at(0) || [],
      ...(await serverSideTranslations(locale, ["common", "product"])),
    },
  };
}
